import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { Notification } from '../entities/entities';

@Injectable()
export class NotifyService {

  onNotifyChange: Subject<Notification> = new Subject<Notification>();

  constructor() { }

  public notifyError(notification: Notification) : void {
    this.onNotifyChange.next(notification);
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/services/notify.service.ts